import React from 'react';

interface EventItemProps {
  eventId: number;
  eventName: string;
  eventDescription?: string;
  eventDate?: string;
  attending?: boolean | null;
  onResponseChange: (eventId: number, attending: boolean) => void;
}

const EventItem: React.FC<EventItemProps> = ({
  eventId,
  eventName,
  eventDescription,
  eventDate,
  attending,
  onResponseChange,
}) => {
  return (
    <div className="event-item">
      <div className="event-info">
        <div className="event-name">{eventName}</div>
        {eventDate && <div className="event-date">{eventDate}</div>}
        {eventDescription && <div className="event-description">{eventDescription}</div>}
      </div>
      <div className="event-response">
        <div className="response-btn">
          <input
            type="radio"
            id={`${eventId}-yes`}
            name={`event-${eventId}`}
            checked={attending === true}
            onChange={() => onResponseChange(eventId, true)}
          />
          <label htmlFor={`${eventId}-yes`} className="response-label yes">
            Oui
          </label>
        </div>
        <div className="response-btn">
          <input
            type="radio"
            id={`${eventId}-no`}
            name={`event-${eventId}`}
            checked={attending === false}
            onChange={() => onResponseChange(eventId, false)}
          />
          <label htmlFor={`${eventId}-no`} className="response-label no">
            Non
          </label>
        </div>
      </div>
    </div>
  );
};

export default EventItem;
